"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));

var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));

var _CornerstoneCard = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCard"));

var _Button = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Button"));

var _CornerstoneModal = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneModal"));

var _DraggableTitle = _interopRequireDefault(require("../DraggableTitle/DraggableTitle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Persona = /*#__PURE__*/function (_Component) {
  _inherits(Persona, _Component);

  var _super = _createSuper(Persona);

  function Persona(props) {
    var _this;

    _classCallCheck(this, Persona);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCloseModal", function () {
      _this.props.onCancel();
    });

    _this.state = {};
    return _this;
  }

  _createClass(Persona, [{
    key: "render",
    value: function render() {
      var superUserList = [];

      if (JSON.parse(sessionStorage.getItem("userPersonaObj")) && JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList && JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList.length && localStorage.getItem("AppId") === "PDS") {
        superUserList = JSON.parse(sessionStorage.getItem("userPersonaObj")).superUserList;
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CornerstoneModal.default, {
        title: /*#__PURE__*/_react.default.createElement(_DraggableTitle.default, {
          title: "My Persona"
        }),
        width: "50%",
        visible: this.props.openMyPersona,
        onCancel: this.onCloseModal,
        footer: null,
        maskClosable: false
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
        className: "mt-2"
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        key: "pdsp",
        label: "PDS Persona(s)"
      })), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
        sm: 1
      }), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneCard.default, {
        sm: 1
      }, this.props.userPersonaList ? this.props.userPersonaList.map(function (obj) {
        return /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "mt-1",
          type: "default",
          style: {
            borderColor: "grey",
            color: "black",
            marginRight: ".5rem"
          }
        }, Object.values(obj)[1]);
      }) : null)), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null), superUserList && superUserList.length ? /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
        className: "mt-4"
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        key: "surs",
        label: "Super User Rights",
        style: {
          color: "black"
        }
      }, superUserList && superUserList.length ? superUserList.join(", ") : null)) : null)));
    }
  }]);

  return Persona;
}(_react.Component);

var _default = _CornerstoneForm.default.create({
  name: "Persona"
})(Persona);

exports.default = _default;